export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyświetlono:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ogółem"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Na stronie"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pokaż"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyniki"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["z"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handel"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transakcje"])}
}